var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.603H7.396V1.5a.137.137 0 0 0-.136-.136h-.443a6.792 6.792 0 0 0-4.82 1.996A6.787 6.787 0 0 0 0 8.182a6.792 6.792 0 0 0 1.996 4.82A6.786 6.786 0 0 0 6.818 15a6.79 6.79 0 0 0 4.82-1.996 6.785 6.785 0 0 0 1.461-2.166c.356-.84.538-1.744.537-2.656V7.74a.137.137 0 0 0-.136-.136ZM10.8 12.2a5.652 5.652 0 0 1-4.01 1.64 5.622 5.622 0 0 1-3.975-1.657 5.623 5.623 0 0 1-1.657-4.002c0-1.512.588-2.933 1.657-4.002a5.61 5.61 0 0 1 3.422-1.628v6.21h6.21a5.613 5.613 0 0 1-1.647 3.44ZM15 6.655l-.044-.48a6.78 6.78 0 0 0-1.963-4.17 6.808 6.808 0 0 0-4.18-1.96L8.33 0a.135.135 0 0 0-.148.134v6.547c0 .075.06.136.136.136l6.545-.017c.08 0 .143-.068.136-.146Zm-5.662-.992V1.289a5.663 5.663 0 0 1 2.837 1.53 5.628 5.628 0 0 1 1.534 2.832l-4.37.012Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.657bf6bd4be36b32e86279b63ebe6a56.svg";
export { ForwardRef as ReactComponent };